import { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Context } from "../../../Context";

import Navbar from "../../../components/Navbar";
import Leaderboard from "../../../components/Leaderboard";
import FishCard from "../../../components/FishDisplay";

import { PiRankingLight } from "react-icons/pi";
import { BsGraphUp } from "react-icons/bs";
import { GiFishingPole, GiFishingHook } from "react-icons/gi";
import { LiaFishSolid } from "react-icons/lia";

const ServerStats = () => {
  const context = useContext(Context);
  const accessToken = context.accessToken;
  const discordAccessToken = context.session?.provider_token;
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const serverId = useParams().serverId;
  const navigate = useNavigate();
  const location = useLocation();
  const server = location.state?.serverData;
  const [serverStats, setServerStats] = useState(null);

  useEffect(() => {
    // Get server stats from API
    const serverStats = async () => {
      if (!accessToken || !discordAccessToken) return; // Wait until tokens are available

      try {
        const response = await fetch(`${apiBaseUrl}/api/servers/${serverId}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`, // Supabase JWT in header
          },
          body: JSON.stringify({ discord_access_token: discordAccessToken }),
        });
        if (response.status === 404) navigate("/404");

        const serverStatsData = await response.json();
        setServerStats(serverStatsData);
      } catch (error) {
        console.error("Failed to fetch server stats data", error);
      }
    };

    serverStats();
  }, [serverId, navigate, apiBaseUrl, accessToken, discordAccessToken]);

  return (
    <div className="mb-20">
      <Navbar />
      <div className="w-4/5 my-0 mx-auto">
        <a
          className="inline-block text-2xl mt-6 hover:underline"
          href="/user/profile"
          rel="noopener noreferrer"
        >
          {"<- Profile"}
        </a>
        <div className="flex flex-col xl:flex-row mt-12">
          <div className="flex flex-col mr-32">
            <img
              className="w-64 rounded-full border-black border-2"
              src={
                server?.icon
                  ? server?.icon
                  : require("../../../images/discord_logo_large.png")
              }
              alt="Server Icon"
            />
            <h1 className="text-3xl">{server?.name}</h1>
            <p className="text-xs">Server ID: {serverId}</p>
          </div>

          <div>
            <h1 className="text-4xl mb-6">Your Statistics</h1>
            <div className="flex flex-col  md:flex-row ">
              {/* ALL TIME STATS*/}
              <div className="flex flex-col items-center bg-[var(--blue)] rounded-md p-5 md:mr-16 mb-4 md:mb-0">
                <h3 className="flex justify-center font-medium text-xl">
                  Lifetime
                </h3>

                <div className="flex flex-col">
                  <h3 className="flex items-center py-1 px-3">
                    <PiRankingLight className="mr-2" />
                    Rank:{" "}
                    {serverStats ? serverStats?.allTimeLeaderboardPosition : 0}
                  </h3>
                  <h3 className="flex items-center py-1 px-3">
                    <GiFishingPole className="mr-2" />
                    Total Catches:{" "}
                    {serverStats ? serverStats?.allTimeCatches : 0}
                  </h3>
                  <h3 className="flex items-center py-1 px-3">
                    <GiFishingHook className="mr-2" />
                    Lost Lures:{" "}
                    {serverStats ? serverStats?.allTimeLostLures : 0}
                  </h3>
                  <h3 className="flex items-center py-1 px-3">
                    <BsGraphUp className="mr-2" />
                    K/D Ratio: {serverStats ? serverStats?.allTimeKdRatio : 0}
                  </h3>
                  <h3 className="flex items-center py-1 px-3">
                    <LiaFishSolid className="mr-2" />
                    Last Catch: {serverStats && serverStats?.lastCatchDate}
                    {serverStats &&
                      serverStats?.daysSinceLastCatch !== -1 &&
                      ` (${serverStats?.daysSinceLastCatch} days ago)`}
                  </h3>
                </div>
              </div>

              {/* SEASON STATS*/}
              <div className="flex flex-col items-center bg-[var(--blue)] rounded-md p-5">
                <h3 className="flex justify-center font-medium text-xl">
                  Season {serverStats ? serverStats["currentSeason"] : 0}
                </h3>

                <div className="flex flex-col">
                  <h3 className="flex items-center py-1.5 px-3">
                    <PiRankingLight className="mr-2" />
                    Rank:{" "}
                    {serverStats ? serverStats["currentSeasonPosition"] : 0}
                  </h3>
                  <h3 className="flex items-center py-1.5 px-3">
                    <GiFishingPole className="mr-2" />
                    Total Catches:{" "}
                    {serverStats ? serverStats["currentSeasonNumCatches"] : 0}
                  </h3>
                  <h3 className="flex items-center py-1.5 px-3">
                    <GiFishingHook className="mr-2" />
                    Lost Lures:{" "}
                    {serverStats ? serverStats["currentSeasonLostLures"] : 0}
                  </h3>
                  <h3 className="flex items-center py-1.5 px-3">
                    <BsGraphUp className="mr-2" />
                    K/D Ratio:{" "}
                    {serverStats ? serverStats["currentSeasonKdRatio"] : 0}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>

        <h1 className="mt-12 mb-4 text-4xl">Leaderboards</h1>
        <Leaderboard />

        <h1 className="mt-12 mb-4 text-4xl">Fish Gallery</h1>
        <FishCard imageUrl={""} />
      </div>
    </div>
  );
};

export default ServerStats;
